import { SMLRouteNames, SMLRoutes } from './SMLRoutes';
import { outreachRouteOfPath } from './smlRoutePath';

/**
 * The routes whose sub-pages are plain path segments (`/streaming/tracks`, `/social/post/12`).
 * A sub-page segment can have the name of another route (`tracks`, `playlists`), so the first
 * segment decides for these paths. Else `/streaming/tracks` would light the public Tracks item.
 */
const SECTION_ROOTS: ReadonlySet<string> = new Set<string>([SMLRouteNames.streaming, SMLRouteNames.social]);

export function extractLocationFromPath(path: string) {
  if (path === '') {
    return undefined;
  }
  const strippedPath = path[0] === '/' ? path.slice(1) : path;
  const pathParts = strippedPath.split('/');
  const firstPart = pathParts[0];
  // The Outreach pages: the segment after `outreach` names the page (`/outreach/campaigns/<uuid>/review`).
  if (firstPart === SMLRouteNames.outreach) {
    return SMLRoutes[outreachRouteOfPath(pathParts.slice(1))];
  }
  if (firstPart !== undefined && SECTION_ROOTS.has(firstPart)) {
    return SMLRoutes[firstPart as keyof typeof SMLRouteNames];
  }
  // We find route by last route name (due to issues with navigating in native, we can have only last route path)
  const routeName = pathParts[pathParts.length - 1];
  const fromLast = SMLRoutes[routeName as keyof typeof SMLRouteNames];
  if (fromLast !== undefined) {
    return fromLast;
  }
  // Fallback to the first segment for routes whose tail is a dynamic
  // parameter, e.g. /public/:code, where the last segment is the code itself
  // and won't match any route name.
  return SMLRoutes[firstPart as keyof typeof SMLRouteNames];
}
